import { Culture, Cultures, regionIdToCulture } from "../../Contract/Culture";
import { RegionId } from "../../Contract/RegionId";

export const getCurrency = (culture: RegionId | Culture) => {
  if (typeof culture === "number") {
    const fromRegionId = regionIdToCulture(culture);
    if (fromRegionId === undefined) return;

    culture = fromRegionId;
  }

  switch (culture) {
    case Cultures.Norwegian:
      return "NOK";
    case Cultures.Swedish:
      return "SEK";
    case Cultures.Danish:
      return "DKK";
    case Cultures.FinnishSwedish:
    case Cultures.Finnish:
    case Cultures.Spanish:
    case Cultures.German:
      return "EUR";
  }
};
